import moment from "moment-timezone";
import { normalizeRows } from "./pictreeSaitamaPhotoShoot";

const streetLightExists = (alias) => `
  EXISTS (
    SELECT 1
    FROM power_asset_detail_of_saitama_city sc
    JOIN street_light sl ON sl.id = sc.power_asset_id
    WHERE sc.power_asset_id = ${alias}.power_asset_id
  )`;

const query = (sql) => ({ query: sql, database: "KpiDashboard", type: "list" });

const reportWhere = ({ seasonId, startUtc, endUtc }) => `
  rr.game_space_id = '${seasonId}'
  AND rr.type = 'REGULAR'
  AND rr.display_flag = 1
  AND rr.report_datetime >= '${startUtc}'
  AND rr.report_datetime < '${endUtc}'
  AND ${streetLightExists("rr")}`;

export const buildSaitamaReportQueries = ({ seasonId, startUtc, endUtc }) => {
  const where = reportWhere({ seasonId, startUtc, endUtc });
  const dateBucket = "DATE(DATE_ADD(rr.report_datetime, INTERVAL 9 HOUR))";
  return {
    reportCount: query(`SELECT COUNT(DISTINCT rr.id) AS total_report_count
      FROM report rr WHERE ${where};`),
    reporterCount: query(`SELECT COUNT(DISTINCT rr.player_id) AS total_reporter_count
      FROM report rr WHERE ${where};`),
    tags: query(`SELECT rcd.tag_id, rcd.tag_label,
        COALESCE(MAX(rtdc.description), rcd.tag_label) AS tag_description,
        COUNT(DISTINCT rr.id) AS tag_report_count
      FROM report rr
      JOIN report_content_detail rcd ON rcd.report_id = rr.id
      LEFT JOIN report_tag_display_content rtdc
        ON rtdc.report_tag_id = rcd.tag_id AND rtdc.language_code = 'JA'
      WHERE ${where}
      GROUP BY rcd.tag_id, rcd.tag_label
      ORDER BY rcd.tag_label ASC;`),
    trend: query(`SELECT ${dateBucket} AS report_date, rcd.tag_id, rcd.tag_label,
        COUNT(DISTINCT rr.id) AS report_count
      FROM report rr
      JOIN report_content_detail rcd ON rcd.report_id = rr.id
      WHERE ${where}
      GROUP BY ${dateBucket}, rcd.tag_id, rcd.tag_label
      ORDER BY report_date ASC, rcd.tag_label ASC;`),
  };
};

export const normalizeSaitamaReportDate = (value) => String(value || "").slice(0, 10);

export const makeSaitamaReportDateKeys = (dateRange) => {
  const current = moment.tz(dateRange[0], "YYYY-MM-DD", "Asia/Tokyo");
  const end = moment.tz(dateRange[1], "YYYY-MM-DD", "Asia/Tokyo");
  const keys = [];
  while (current.isSameOrBefore(end, "day")) {
    keys.push(current.format("YYYY-MM-DD"));
    current.add(1, "day");
  }
  return keys;
};

const firstNumber = (rows, key) => rows[0] && rows[0][key] !== undefined ? Number(rows[0][key]) : undefined;

export const buildSaitamaReportOverview = ({ responses, dateRange }) => {
  const tags = normalizeRows(responses.tags).map((row) => ({
    tag_id: row.tag_id,
    tag_label: row.tag_label,
    tag_description: row.tag_description || row.tag_label,
    total_count: Number(row.tag_report_count || 0),
  }));
  const tagAssignmentCount = tags.reduce((sum, tag) => sum + tag.total_count, 0);
  const reportStats = tags.map((tag) => ({
    ...tag,
    percent: tagAssignmentCount > 0 ? (tag.total_count / tagAssignmentCount) * 100 : 0,
  }));
  const trendRows = normalizeRows(responses.trend);
  const tagOrder = tags.map((tag) => tag.tag_label);
  const dateKeys = makeSaitamaReportDateKeys(dateRange);
  const trendByDate = trendRows.reduce((acc, row) => {
    const date = normalizeSaitamaReportDate(row.report_date);
    if (!acc[date]) acc[date] = {};
    acc[date][row.tag_label] = Number(row.report_count || 0);
    return acc;
  }, {});
  const reportTrend = dateKeys.map((date) => ({
    date,
    ...tagOrder.reduce((row, tag) => ({ ...row, [tag]: trendByDate[date]?.[tag] || 0 }), {}),
  }));
  return {
    totalReportCount: firstNumber(normalizeRows(responses.reportCount), "total_report_count"),
    totalReporterCount: firstNumber(normalizeRows(responses.reporterCount), "total_reporter_count"),
    tagAssignmentCount,
    reportStats,
    reportTrend,
    tagOrder,
  };
};

